import {AppStateService} from "./appStateService";
import {SvgService} from "./svgService";
import {UIService} from "../components/UIService";
import {DrawingDataService} from "../components/drawingComponent/drawingDataService";

export class ApiDataService {

    private appStateService: AppStateService;
    private svgService: SvgService;
    private uiService: UIService;
    private drawingDataService: DrawingDataService;

    constructor() {
        this.appStateService = new AppStateService();
        this.svgService = new SvgService();
        this.uiService = new UIService();
        this.drawingDataService = new DrawingDataService();
    }

    getDataForProductApiCall()
    {
        const dataStore = this.appStateService.getProductDataStore();
        const svg = this.svgService.get(dataStore.data[0].type);
        const app = this.uiService.getElementById('app');
        const editedProductId = this.uiService.getAttributeFromElement(app, 'orderProductId');
        const apiRequestObject = [];

        apiRequestObject.push(dataStore.data[0]);
        apiRequestObject.push(this.getDrawingDataApiObject());
        apiRequestObject.push(svg[0]);
        apiRequestObject.push(svg[1]);

        return {
            data: apiRequestObject,
            meta: {
                itemId: editedProductId,
            },
            productInfo: dataStore.productInfo,
            "_csrfToken": this.uiService.getMetaTagContent('csrfToken'),
        };
    };

    getDataForCalculatePriceApiCall()
    {
        const dataStore = this.appStateService.getProductDataStore();
        const apiRequestObject = [];

        apiRequestObject.push(dataStore.data[0]);
        apiRequestObject.push(this.getDrawingDataApiObject());

        return {
            data: apiRequestObject,
            productInfo: dataStore.productInfo,
        };
    };

    private getDrawingDataApiObject()
    {
        if (this.appStateService.getAppSettingOption('iccDrawing')) {
            return {
                sashData: this.drawingDataService.getSashesDimensions(),
                shapeData: this.drawingDataService.getShapeDimensions(),
                mullionsLength: this.drawingDataService.getMullionsLengthInMeters(),
                muntinFieldsCount: this.drawingDataService.getMuntinsFieldsCount(),
                bottomPanelArea: this.drawingDataService.getBottomPanelSquareMeterArea(),
                glassArea: this.drawingDataService.getGlassSquareMeterArea(),
                hasBottomPanel: this.drawingDataService.hasBottomPanel(),
                mainSashCount: this.drawingDataService.getMainSashCount(),
                shape: this.drawingDataService.getShape(),
            }
        }

        return {};
    }
}
